import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__ from "@radix-ui/react-slot";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__helpers_mapClass_js_8e73aa1a__ from "../helpers/mapClass.js";
import * as __WEBPACK_EXTERNAL_MODULE__shared_shared_prop_js_bc881259__ from "../shared/shared.prop.js";
import * as __WEBPACK_EXTERNAL_MODULE__box_prop_js_e3299ce1__ from "./box.prop.js";
const boxClasses = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)({}, {
    variants: {
        display: (0, __WEBPACK_EXTERNAL_MODULE__helpers_mapClass_js_8e73aa1a__.mapClass)(__WEBPACK_EXTERNAL_MODULE__box_prop_js_e3299ce1__.displayValues, 'display'),
        ...__WEBPACK_EXTERNAL_MODULE__shared_shared_prop_js_bc881259__.sharedStyles.cx
    }
});
function Box(props) {
    const { asChild, as, display, children, cx, ref, ...boxProps } = props;
    const Tag = as || 'div';
    const Comp = asChild ? __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__.Slot : Tag;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
        ...boxProps,
        ref: ref,
        className: boxClasses({
            display,
            ...cx
        }),
        children: children
    });
}
export { Box as default };

//# sourceMappingURL=Box.js.map